// extracted by mini-css-extract-plugin
export var arrowIcon = "Button-module--arrowIcon--XwTpA";
export var buttonArrowHover = "Button-module--buttonArrowHover--OLLRl";
export var buttonBackground = "Button-module--buttonBackground--y00YX";
export var buttonFadeHover = "Button-module--buttonFadeHover--sIiyG";
export var buttonFullWidth = "Button-module--buttonFullWidth--gYnQG";
export var buttonNoHover = "Button-module--buttonNoHover--XPjcj";
export var buttonStyles = "Button-module--buttonStyles--3Prvs";
export var buttonText = "Button-module--buttonText--UH1G9";
export var disabledButton = "Button-module--disabledButton--QQkGZ";